import Vue from "vue"
Vue.filter('humanizeDate', function(value) {
    if (!value) return ''
    let humanizedDate = new Date(value).toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })
    // return Date(value).toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })
    return humanizedDate; 
})
